<div class="blog-preview-wrapper">
  <div class="blog-banner">
    <div class="blog-banner-content">
      <div class="blog-title">
        {{ previewData?.title }}
      </div>
      <div class="blog-meta">{{ previewData?.category }} |</div>
    </div>
  </div>

  <div class="blog-container">
    <div class="blog-content">
      <div [innerHTML]="content"></div>
    </div>

    <div class="blog-sidebar">
      <div class="related-title">Related Articles</div>
      <div class="related-list">
        <div class="related-item" *ngFor="let article of relatedArticles">
          <div class="related-text">
            <a [routerLink]="['/blog', article.slug]" class="related-link">
              {{ article.title }}
            </a>
            <div class="related-date">
              {{ article.date | date : "dd MMM yyyy" }}
            </div>
          </div>
          <img [src]="article.coverImg" alt="" class="related-img" />
        </div>
      </div>
    </div>
  </div>
</div>
